<template>
    <!-- Structure with banner, sidebar, ... -->
    <div class="ba6-layout-settings">
      <!-- Banner -->
      <builderall-banner
        :title="t.label_settings"
        :subtitle="t.account_settings"
        :description="t.description_account_settings"
      />

      <!-- Content -->
      <div class='ba-app-wrapper ba-gp-1'>
        <div class='ba-sidebar'>
          <ul class='ba-nav'>
            <li v-for="(route, i) in routes" :key="i" v-if="route.route !== 'affiliation' || (route.route === 'affiliation' && view.affiliation.is_affiliate === '1')"
                class='ba-nav-item'
                @click="callback(route.route)"
            >
              <div :class="['ba-link', route.status ? 'ba-is-active' : '']">
                <builderall-icon :code="route.route === 'account-info' ? '8236' : '6d01'" />
                <span class='ba-title ba-text-capitalize' v-html="route.title"></span>
              </div>
            </li>
          </ul>
          <div class='ba-bottom'>
            <ul class='ba-bottom-list'>
              <li>
                <builderall-help></builderall-help>
              </li>
            </ul>
          </div>
        </div>
        <div class='ba-container ba-flex ba-gp-1 ba-ai-baseline ba-jc-center ba-f-wrap'>
          <div v-if="routes.find(x => x.status)['route'] != 'quotas'" class='ba6-profile-data-card ba-card ba-w-100'>
            <div class="ba-flex ba-gp-2 ba-ai-center ba-h-100">
              <div class="ba6-box-gravatar-image">
                <span v-html="view.account_info.gravatar"></span>
                <builderall-icon class="ba6-over-icon" code='edit'></builderall-icon>
                <a class="ba6-link-gravatar" href="http://gravatar.com/" target="_blank">
                  {{ t.label_change }} <br> {{ t.label_imagem }}
                  <builderall-icon code='edit'></builderall-icon>
                </a>
              </div>
              <div class="ba6-box-element ba-flex ba-f-column ba-gp-02">
                <span v-text="view.account_info.plan"></span>
                <span v-text="t.latest_plan"></span>
              </div>
              <hr class='ba-hr-column'>
              <div class="ba6-box-element ba-flex ba-f-column ba-gp-02">
                <span v-text="view.account_info.user_data.pag_validade"></span>
                <span v-text="t.renewal_date"></span>
              </div>
            </div>
            <span class="ba-montserrat-bold ba-flex ba-ai-center ba-gp-06 ">
              {{ t.label_user_status_account }}: 
              <span :class="['ba-circle', 'ba-lg', getAccountStatus()]"></span>
            </span>
          </div>
          <div class='ba-w-100'>
            <slot />
          </div>
        </div>
        <div class='ba-footer'>
          <builderall-footer></builderall-footer>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: "ba6-layout-settings",
  props: ['view', 'routes', 'callback','t'],
  methods: {
    getAccountStatus(){
      const today       = new Date();
      const pagValidity = new Date(this.view.account_info.user_data.pag_validade);
      return pagValidity >= today ? 'ba-green' : 'ba-red';
    }
  }
}
</script>

<style scoped lang="scss">
.ba-app-wrapper{
  padding-bottom: 70px !important;
  .ba6-profile-data-card{
    height: 135px;
    display: grid;
    grid-template-columns: 1fr auto;
    .ba6-box-element{
      span{
        &:first-child{
          font-size: 24px;
          font-weight: 700;
        }
        &:last-child{
          color: #54779E;
          font-size: 12px;
          font-weight: 500;
        }
      }
    }
  }
}
.ba6-box-gravatar-image{
  position: relative;
  &:hover{
    .ba6-over-icon{
      display: none;
    }
    .ba6-link-gravatar{
      display: flex;
    }
  }
  .ba6-over-icon{
    bottom: 5px;
    right: 15px;
    position: absolute;
  }
  builderall-icon{
    --builderall-icon-size: 15px;
    --builderall-icon-color: #fff;
  }
  .ba6-link-gravatar{
    display: none;
    position: absolute;
    bottom: 0;
    background: rgba(77, 93, 113, 0.80);
    left: 0;
    border-radius: 0 0 200px 200px;
    color: #FFF;
    text-align: center;
    font-size: 8px;
    font-weight: 500;
    height: 50%;
    width: 80px;
    gap: 2px;
    align-items: center;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/office-v6/account-settings/components/layoutSettings.vue